module.exports = __webpack_public_path__ + "static/media/export.01ff6b3d.svg";